export const CST_TYPE = {
  OFFLINE: 0,
  ONLINE: 1,
};

export const CST_STATE = {
  OFF: 0,
  ON: 1,
};

export const CST_PAGE_SIZE = 20;

export const CST_TYPE_FILTER_OPTIONS = [
  { value: '', label: '全部' },
  { value: String(CST_TYPE.OFFLINE), label: '線下客服' },
  { value: String(CST_TYPE.ONLINE), label: '在線客服' },
];

export const CST_STATE_FILTER_OPTIONS = [
  { value: '', label: '全部' },
  { value: String(CST_STATE.ON), label: '啟用' },
  { value: String(CST_STATE.OFF), label: '禁用' },
];

export const CST_FORM_TYPE_OPTIONS = [
  { value: CST_TYPE.OFFLINE, label: '線下客服' },
  { value: CST_TYPE.ONLINE, label: '在線客服' },
];

export const CST_FORM_STATE_OPTIONS = [
  { value: CST_STATE.ON, label: '啟用' },
  { value: CST_STATE.OFF, label: '禁用' },
];

export function buildCustomerServiceTypePageParams(pageNo, filters = {}, pageSize = CST_PAGE_SIZE) {
  const params = { pageNo, pageSize };
  if (filters.state !== '' && filters.state != null) {
    params.state = Number(filters.state);
  }
  if (filters.type !== '' && filters.type != null) {
    params.type = Number(filters.type);
  }
  if (filters.name?.trim()) {
    params.name = filters.name.trim();
  }
  return params;
}

export function formatCustomerServiceTypeState(state) {
  return state === CST_STATE.ON ? '啟用' : '禁用';
}

export function formatCustomerServiceTypeType(type) {
  return type === CST_TYPE.ONLINE ? '在線客服' : '線下客服';
}

export function emptyCustomerServiceTypeDetail(lang) {
  return {
    lang,
    name: '',
  };
}

export function mergeCustomerServiceTypeDetailsWithLanguages(languages, existingDetails = []) {
  const langEntries = [];
  const seen = new Set();

  (languages || []).forEach((lang) => {
    const code = lang.code || lang;
    if (!code || seen.has(code)) {
      return;
    }
    seen.add(code);
    langEntries.push({
      code,
      label: lang.label || code,
    });
  });

  (existingDetails || []).forEach((item) => {
    if (!item?.lang || seen.has(item.lang)) {
      return;
    }
    seen.add(item.lang);
    langEntries.push({
      code: item.lang,
      label: item.lang,
    });
  });

  const map = new Map((existingDetails || []).map((item) => [item.lang, { ...item }]));
  return langEntries.map(({ code, label }) => {
    const found = map.get(code);
    return found
      ? { ...found, lang: code, _label: label }
      : { ...emptyCustomerServiceTypeDetail(code), _label: label };
  });
}

export function stripCustomerServiceTypeDetails(details) {
  return (details || []).map(({ lang, name }) => ({
    lang,
    name: name || '',
  }));
}
